import { socialConstants } from '../constants';

export const socialLogin = {
  prepare: (service, options) => ({ type: socialConstants.SOCIAL_LOGIN_PREPARE, service, options }),
  request: (service, options) => ({ type: socialConstants.SOCIAL_LOGIN_REQUEST, service, options }),
  success: (user) => ({ type: socialConstants.SOCIAL_LOGIN_SUCCESS, user }),
  failure: (error) => ({ type: socialConstants.SOCIAL_LOGIN_FAILURE, error })
}

export const socialLogout = () => ({ type: socialConstants.SOCIAL_LOGOUT })